import React, { Fragment } from "react";
import makeStyles from "@mui/styles/makeStyles";
import { Link, useNavigate } from "react-router-dom";
import {
  OrganizeViews,
  getContentGroupsViewPath,
  getUngroupedItemsViewPath,
  isCollectionView,
  isModuleView,
  useView,
  useViews,
} from "../organizeUtil";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/pro-regular-svg-icons";
import { notBlank } from "../../../util/ext";
import { useSelected } from "../OrganizeProvider";
import { includes } from "ramda";
import { useIsAdmin } from "../../../auth/authUtils";

import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";

import OrganizeButton from "../common/OrganizeButton";

const useStyles = makeStyles(theme => ({
  root: {
    gap: 10,
  },

  link: {
    color: theme.palette.brandPrimary,
  },

  tooltip: {
    maxWidth: 700,
  },
}));

const Header = ({ media }) => {
  const classes = useStyles();
  if (media.isLoading) {
    return <Skeleton width="200px" />;
  }

  if (media.isSuccess) {
    return (
      <Tooltip title={media.data.name} classes={{ tooltip: classes.tooltip }}>
        <Typography variant="h1" noWrap>
          {media.data.name}
        </Typography>
      </Tooltip>
    );
  }

  if (media.isError) {
    return null;
  }
};

const ContentGroupsBreadcrumbs = ({ breadcrumbs, media }) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const view = useView();
  const views = useViews();
  const isAdmin = useIsAdmin();
  const { removeAllSelected } = useSelected();

  const goHome = () => {
    removeAllSelected();

    const homePath = includes(OrganizeViews.CONTENT_GROUPS, views)
      ? getContentGroupsViewPath()
      : getUngroupedItemsViewPath();

    navigate(homePath);
  };

  return (
    <Grid
      className={classes.root}
      container
      item
      xs={isCollectionView(view) ? 4 : 6}
      sm={7}
      md={isModuleView(view) && !isAdmin ? 7 : 8}
      xl={isModuleView(view) && !isAdmin ? 7 : 8}
      alignItems="center"
    >
      <Grid item xs="auto" style={{ marginLeft: "-12px", marginRight: "-8px" }}>
        <OrganizeButton
          aria-label="Return to Organize home screen"
          color="primary"
          size="large"
          onClick={goHome}
        >
          Organize
        </OrganizeButton>
      </Grid>

      {notBlank(breadcrumbs) &&
        breadcrumbs.map((breadcrumb, idx) => (
          <Fragment key={breadcrumb.id}>
            <Grid item xs="auto">
              <FontAwesomeIcon icon={faAngleRight} />
            </Grid>

            {breadcrumbs.length - 1 === idx ? (
              <Grid item xs zeroMinWidth className={classes.header}>
                <Header media={media} />
              </Grid>
            ) : (
              <Grid item xs="auto">
                <Link className={classes.link} to={breadcrumb.viewPath}>
                  ...
                </Link>
              </Grid>
            )}
          </Fragment>
        ))}
    </Grid>
  );
};

export default ContentGroupsBreadcrumbs;
